import { useMutation, useQuery } from '@apollo/client';
import {
  AppContext,
  B1,
  toast,
  getTranslatedText,
  BrandingLogo,
  BackgroundIcon,
  getCustomSubDomain,
  getHeaderValue,
  getIdpHeaders,
  useUserMSPCheckHookBasedOnProduct,
  fetchApi,
  Loader
} from '@nile/components';
import { AccountClient } from '@nile/graphql/src';
import {
  GET_USER_PASSWORD_POLICY,
  GET_USER_TFA_DETAIL,
  UPDATE_USER_PASSWORD_V2,
  VALIDATE_PASSWORD,
  VERIFY_CURRENT_PASSWORD,
  VERIFY_PASSWORD_PASSCODE
} from '@nile/graphql/src/Query/profile';
import envConfig from '@nile/home/src/Config/env';
import {
  Banner,
  Button,
  Icon,
  SkeletonBodyText,
  TextField
} from '@superops/ui-design-system';
import {
  CircleCancelMinor,
  CircleTickOutlineMinor
} from '@shopify/polaris-icons';
import * as _ from 'lodash';
import { cloneDeep, isEmpty } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import OtpInput from 'react-otp-input';
import styled from 'styled-components';
import { SVGIcon } from '@superops/super-icons';

const otpInputStyle = {
  height: '65px',
  width: '65px',
  fontSize: '24px',
  fontWeight: 'bold',
  outline: 'none',
  marginRight: '12px',
  border: '1px solid #CDCDCD',
  borderRadius: '4px'
};

const errorText = {
  default: 'app.scheduling.errorcode.70002.message',
  user_not_exist: 'app.errorcode.user.notExist',
  different_email: 'app.errorcode.login.different.mail',
  user_not_activated: 'app.auth.userAccountNotActivated',
  wrong_password: 'app.auth.passwordMismatch',
  user_locked: 'app.auth.userAccountLocked',
  wrong_token: 'app.errorCode.556',
  invalid_token: 'app.errorCode.556',
  wrong_code: 'app.idp.auth.invalidCode',
  invalid_request: 'app.errorCode.1014',
  invalid_captcha_token: 'app.idp.auth.captcha.invalid',
  password_mismatch: 'app.auth.passwordMismatch',
  password_policy_violation: 'app.auth.pwdFullfillReq',
  captcha_validation_failed: 'app.idp.auth.captcha.invalid',
  invalid_input: 'app.idp.auth.invalidInput',
  customer_inactive: 'app.auth.userAccountNotActivated',
  unknown: 'app.idp.auth.error.unknown',
  no_user: 'app.auth.noUserFound',
  network: 'common.networkError',
  target_failed: 'common.redirectTargetFailed',
  recently_used: 'app.auth.passwordNoPrevXPassword',
  too_short: 'app.auth.passwordLengthGreaterThanX',
  too_long: 'app.auth.passwordLengthGreaterThan100',
  empty: 'app.auth.emptyPassword',
  missing_alphanumeric: 'app.auth.passwordNoAlphaNumeric',
  missing_character_mix: 'app.auth.passwordNoMixcase',
  missing_special_character: 'app.auth.passwordNoSpecialChar',
  same_as_email: 'app.auth.passwordEmailNotAllowed',
  same_as_current_password: 'admin.passwordPolicy.notMatchPrevious'
};

const Wrapper = styled.div`
  background: linear-gradient(
    180deg,
    rgba(218, 187, 243, 0) 4.2%,
    rgba(218, 187, 243, 0.5) 48.27%,
    rgba(218, 187, 243, 0) 100%
  );
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .card-parent {
    box-shadow: 0px 20px 40px -8px rgba(0, 0, 0, 0.1);
    padding: 40px;
    background: #ffffff;
    border-radius: 12px;
  }

  .auth-component {
    flex: 1;
  }

  .login-card {
    min-height: 515px;
  }

  .Polaris-Label__Text {
    color: rgba(0, 0, 0, 0.85) !important;
    font-size: 14px;
    margin-bottom: 4px !important;
  }

  .Polaris-FormLayout__Item {
    margin: 0 !important;
  }

  .Superops-TextField {
    margin-bottom: 5px !important;
  }

  .left-bottom-desc {
    font-size: 24px;
    line-height: 1.5;
    margin-bottom: 70px;
    width: 77%;
    font-weight: bold;
  }

  .user-salutation {
    font-weight: 500;
    font-size: 24px;
    line-height: 29px;
    color: rgba(0, 0, 0, 0.85);
  }
  .salutation-subtext {
    margin-top: 20px;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: rgba(0, 0, 0, 0.6);
  }
  .current-password-visibility-container {
    cursor: pointer;
  }
  .link {
    color: #000ff0;
    margin-top: 20px;
    cursor: pointer;
  }

  .auth-code-container-wrapper {
    height: 100%;
    min-width: 540px;
  }
  .current-password-wrapper {
    min-width: 470px;
  }
  .update-password-wrapper {
    max-width: 540px;
  }
  .help-text {
    font-size: 12px;
    line-height: 21px;
    color: rgba(0, 0, 0, 0.5);
    opacity: 0.8;
  }
  .try-another-way {
    font-size: 14px;
    color: #000ff0;
  }
  .troubles-accessing-auth-label {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #5c5c5c;
  }
  .password-criteria-heading {
    font-size: 12px;
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.5);
    font-weight: 500;
    margin-bottom: 12px;
  }

  .password-criteria {
    font-size: 14px;
    letter-spacing: 0.875px;
    color: #242424;
  }

  .password-criteria:not(:last-child) {
    margin-bottom: 12px;
  }

  .validated-item {
    opacity: 0.3;
  }
  .password-validation-text-icon-round {
    background-color: #f05;
    width: 6px;
    height: 6px;
    border-radius: 50%;
  }
  .conditions-block {
    background: #f4f5f7;
    border-radius: 8px;
    padding: 16px 24px;
  }
`;

const URL = {
  EU: {
    alpha: 'https://euauth.superopsalpha.com',
    development: 'https://euauth.superopsalpha.com',
    production: 'https://euauth.superops.ai'
  },
  US: {
    alpha: 'https://usauth.superopsalpha.com',
    development: 'https://usauth.superopsalpha.com',
    production: 'https://usauth.superops.ai'
  }
};
const SecurityConfig = (props) => {
  const {
    handleData,
    isPublic,
    proceedTill,
    buttonLoader,
    validatePwdAttributes,
    createPassword,
    resetPasswordPublic,
    intl,
    getIdpToken,
    setSecurityConfigModal
  } = props;
  const app = useContext(AppContext);
  const isMSPBasedonProduct = useUserMSPCheckHookBasedOnProduct();
  const dcRegion = localStorage.getItem('dcRegion');
  const idpBaseURL = URL?.[dcRegion]?.[envConfig.mode];
  const { user } = app;
  const [idpError, setIdpError] = useState({});
  const [loading, setLoading] = useState(false);

  const allAttributes = [
    {
      key: 'length',
      helpText: ({ length }) => {
        return (
          <FormattedMessage
            id="app.passwordConstraint.length"
            values={{ length: length }}
          />
        );
      },
      isValid: false
    },
    {
      key: 'isAlphaNumeric',
      helpText: () => {
        return <FormattedMessage id="app.passwordConstraint.isAlphaNumeric" />;
      },
      isValid: false
    },
    {
      key: 'isMixCaseWithSpecialChar',
      helpText: () => {
        return (
          <FormattedMessage id="app.passwordConstraint.isMixCaseWithSpecialChar" />
        );
      },
      isValid: false
    }
  ];

  const [idpResetToken, setResetToken] = useState('');
  const [renderType, setRenderType] = useState(props.renderType);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [passCode, setPasscode] = useState('');
  const [isBackUpCode, setIsBackUpCode] = useState(false);
  const [buttonloader, setButtonLoader] = useState(false);
  const [showPassword, setShowPassword] = useState({
    currentPassword: false,
    newPassword: false,
    confirmNewPassword: false
  });
  const [passwordPolicy, setPasswordPolicy] = useState(
    props.passwordPolicy || ''
  );
  const [isNewPasswordVaild, setNewPasswordVaild] = useState(true);

  const [passwordMatchError, setPasswordMatchError] = useState(null);
  const [
    verifyPasswordPasscodeDetails,
    setVerifyPasswordPasscodeDetails
  ] = useState(null);

  const [tfaDetails, setTFADetails] = useState();
  const [validationAttributes, setValidationAttributes] = useState(
    validatePwdAttributes || allAttributes
  );

  const { data: tfaDetailsData } = useQuery(GET_USER_TFA_DETAIL, {
    client: AccountClient,
    skip: isPublic,
    fetchPolicy: 'network-only',
    onCompleted: ({ getCurrentUserTfaDetail }) => {
      setTFADetails(getCurrentUserTfaDetail);
    }
  });

  function filterAttributesToValidate(pwdPolicy) {
    const filteredAttributes = cloneDeep(allAttributes);
    Object.keys(pwdPolicy).forEach((key) => {
      switch (key) {
        case 'length':
          filteredAttributes[0].helpText = () => {
            return (
              <FormattedMessage
                id="app.passwordConstraint.length"
                values={{ length: pwdPolicy.length }}
              />
            );
          };
          break;
        case 'isAlphaNumeric':
          if (pwdPolicy.isAlphaNumeric === false) {
            filteredAttributes.splice(1, 1);
          }
          break;
        case 'isMixCaseWithSpecialChar':
          if (pwdPolicy.isMixCaseWithSpecialChar === false) {
            filteredAttributes.splice(2, 1);
          }
          break;
        default:
          break;
      }
    });
    return filteredAttributes;
  }

  const { data: passWordPolicyData } = useQuery(GET_USER_PASSWORD_POLICY, {
    client: AccountClient,
    skip: isPublic,
    fetchPolicy: 'network-only',
    onCompleted: (res) => {
      setPasswordPolicy(res.getCurrentUserPasswordPolicy);
      const policy = res.getCurrentUserPasswordPolicy;
      const attributesToValidate = filterAttributesToValidate(policy);
      setValidationAttributes(attributesToValidate);
    }
  });

  const [verifyCurrentPassword] = useMutation(VERIFY_CURRENT_PASSWORD, {
    client: AccountClient,
    onCompleted: (data) => {
      if (data?.verifyCurrentPassword) {
        setRenderType('passcode');
      }
      setButtonLoader(false);
    },
    onError: () => {
      setButtonLoader(false);
    }
  });

  const [verifyPasswordPasscode] = useMutation(VERIFY_PASSWORD_PASSCODE, {
    client: AccountClient,
    onCompleted: (res) => {
      if (res) {
        if (proceedTill === 'currentPassword' || proceedTill === 'passcode') {
          handleData(res, renderType);
        } else {
          setRenderType('updatePassword');
          setVerifyPasswordPasscodeDetails(res);
        }
      }
      setButtonLoader(false);
    },
    onError: () => {
      setButtonLoader(false);
    }
  });

  const [updatePassword] = useMutation(UPDATE_USER_PASSWORD_V2, {
    client: AccountClient,
    onCompleted: (res) => {
      setButtonLoader(false);
      handleData(true);
      toast('success', 'admin.profile.password.updated.success');
    },
    onError: (err) => {
      setButtonLoader(false);
    }
  });

  const [validatePassword] = useMutation(VALIDATE_PASSWORD, {
    client: AccountClient,
    onCompleted: (res) => {
      if (isEmpty(res?.validatePassword)) {
        updatePassword({
          variables: {
            newPassword: confirmNewPassword,
            authenticationVerifiedToken:
              verifyPasswordPasscodeDetails.verifyPasswordAndPasscode
          }
        });
      } else {
        setButtonLoader(false);
        //TODO Added Intl
        for (let i in res?.validatePassword) {
          toast('error', i);
        }
      }
    },
    onError: () => {
      setButtonLoader(false);
    }
  });

  /**
   * Showing loader when toggle loader coming from outside
   */
  useEffect(() => {
    setButtonLoader(buttonLoader);
  }, [buttonLoader]);

  useEffect(() => {
    setRenderType(props.renderType);
  }, [props.renderType]);

  useEffect(() => {
    setPasswordPolicy(props.passwordPolicy);
  }, [props.passwordPolicy]);

  const showpasswordHandler = (type) => {
    setShowPassword({
      ...showPassword,
      [type]: !showPassword[type]
    });
  };

  const currentPasswordVerify = () => {
    if (!currentPassword) return;

    if (idpResetToken) {
      setButtonLoader(true);
      setIdpError({});
      fetch(`${idpBaseURL}/api/password/verify`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          ...getIdpHeaders(),
          Authorization: `Bearer ${idpResetToken}`
        },
        body: JSON.stringify({
          password: currentPassword
        })
      })
        .then(async (res) => {
          const data = await res.json();
          if (res.ok && res.status === 200) {
            if (data?.code === 'next_step_required') {
              if (data?.step === 'NEW_PASSWORD') {
                setRenderType('updatePassword');
              } else if (data?.step === 'TOTP' || data?.step === 'VERIFY_MFA') {
                setRenderType('passcode');
              }
            }
          }
          if (!res.ok) {
            setIdpError(data);
          }
        })
        .finally(() => {
          setButtonLoader(false);
        });
      return;
    }
    if (isPublic) {
      handleData(currentPassword, renderType);
    } else {
      setButtonLoader(true);
      if (proceedTill === 'currentPassword') {
        verifyPasswordPasscode({
          variables: {
            currentPassword
          }
        });
      } else if (tfaDetails?.tfaType === 'AUTHENTICATOR') {
        verifyCurrentPassword({
          variables: {
            currentPassword
          }
        });
      } else {
        verifyPasswordPasscode({
          variables: {
            currentPassword
          }
        });
      }
    }
  };

  // useEffect(() => {
  //   setPasscode(passCode);
  // }, [passCode]);

  const verifypassCode = (otp) => {
    if (!otp) return;

    if (isPublic && renderType === 'passcode') {
      handleData(otp, renderType);
    } else {
      setButtonLoader(true);
      verifyPasswordPasscode({
        variables: {
          currentPassword,
          passcode: otp
        }
      });
    }
  };

  const verifybackUpCode = (otp) => {
    if (!otp) return;

    if (isPublic && renderType === 'passcode') {
      handleData(otp, renderType);
    } else setRenderType('updatePassword');
  };

  const tryAnotherWay = () => {
    setPasscode('');
    setIsBackUpCode(!isBackUpCode);
  };

  const changePassword = () => {
    if (!confirmNewPassword || !newPassword) return;

    if (confirmNewPassword !== newPassword) {
      setPasswordMatchError(
        getTranslatedText(intl, 'app.password.do.not.match')
      );
      return;
    }
    if (idpResetToken) {
      setButtonLoader(true);
      setIdpError({});
      fetch(`${idpBaseURL}/api/password/reset`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          ...getIdpHeaders(),
          Authorization: `Bearer ${idpResetToken}`
        },
        body: JSON.stringify({
          newPassword: newPassword,
          confirmPassword: confirmNewPassword
        })
      })
        .then(async (res) => {
          const data = await res.json();
          if (res.ok && res.status === 200) {
            toast('success', 'User details updated successfully');
            setResetToken(null);
            if (setSecurityConfigModal) setSecurityConfigModal(false);
          }
          if (!res.ok) {
            setIdpError(data);
          }
        })
        .finally(() => {
          setButtonLoader(false);
        });
      return;
    }
    if (isPublic) {
      handleData(confirmNewPassword, renderType);
    } else {
      setButtonLoader(true);
      validatePassword({
        variables: {
          password: confirmNewPassword
        }
      });
    }
  };

  function validateAlphaNumeric(password) {
    // const regex = /^(?=.*[a-zA-Z])(?=.*[0-9]).*$/;
    const regex = /^(?=.*[a-zA-Z])(?=.*\d).*$/;
    return regex.test(password);
  }

  function validatePasswordLength(password) {
    if (password?.length >= passwordPolicy?.length) {
      return true;
    }
    return false;
  }

  function validateMixCaseWithSpecialChar(password) {
    const regex = /[^a-zA-Z0-9 ]/;
    return regex.test(password);
  }

  function validatePasswordPolicy(password) {
    const updatedAttributes = cloneDeep(validationAttributes);
    updatedAttributes.forEach((attribute, index) => {
      if (attribute.key === 'isAlphaNumeric') {
        updatedAttributes[index].isValid = validateAlphaNumeric(password);
      }
      if (attribute.key === 'length') {
        updatedAttributes[index].isValid = validatePasswordLength(password);
      }
      if (attribute.key === 'isMixCaseWithSpecialChar') {
        updatedAttributes[index].isValid = validateMixCaseWithSpecialChar(
          password
        );
      }
    });
    setValidationAttributes(updatedAttributes);
  }

  const inputChange = (value, type) => {
    if (type === 'newPassword') validatePasswordPolicy(value);
    setPasswordMatchError('');
    type === 'newPassword'
      ? setNewPassword(value)
      : setConfirmNewPassword(value);
  };

  const handleEnterKey = (e, callingFunction) => {
    if (e.which === 13 || e.charCode === 13 || e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      callingFunction();
    }
  };

  const isButtonDisbled = () => {
    return !_.every(validationAttributes, { isValid: true });
  };

  const handleOTPChange = (otp) => {
    setPasscode(otp);
    setIdpError({});
    const otpLength = otp.length;
    if (
      (isBackUpCode && otpLength === 8) ||
      (!isBackUpCode && otpLength === 6)
    ) {
      if (idpResetToken) {
        setButtonLoader(true);
        fetch(`${idpBaseURL}/api/mfa/totp/verify`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            ...getIdpHeaders(),
            Authorization: `Bearer ${idpResetToken}`
          },
          body: JSON.stringify({
            totpCode: isBackUpCode ? undefined : otp,
            backupCode: isBackUpCode ? otp : undefined
          })
        })
          .then(async (res) => {
            const data = await res.json();
            if (res.ok && res.status === 200) {
              if (data?.code === 'next_step_required') {
                if (data?.step === 'NEW_PASSWORD') {
                  setRenderType('updatePassword');
                } else {
                  setRenderType('updatePassword');
                }
              }
            }
            if (!res.ok) {
              setIdpError(data);
            }
          })
          .finally(() => {
            setButtonLoader(false);
          });
        return;
      }
      if (isBackUpCode) {
        verifybackUpCode(otp);
      } else {
        verifypassCode(otp);
      }
    }
  };

  useEffect(() => {
    setValidationAttributes(validatePwdAttributes);
  }, [validatePwdAttributes]);

  const renderContent = () => {
    switch (renderType) {
      case 'updatePassword':
        return (
          <div className="update-password-wrapper">
            <p className="user-salutation">
              <FormattedMessage
                id={
                  createPassword
                    ? 'admin.myprofile.security.pass.header.set.password'
                    : 'admin.myprofile.security.pass.header'
                }
              />
            </p>
            <p className="salutation-subtext">
              <FormattedMessage id="admin.myprofile.security.choose.strong.password" />
            </p>
            {!isEmpty(idpError) && (
              <div className="mbt20">
                <Banner status="critical">
                  {getTranslatedText(intl, errorText?.[idpError?.code])}
                </Banner>
              </div>
            )}
            <div className="mt-40">
              <div onKeyPress={(e) => handleEnterKey(e, changePassword)}>
                <TextField
                  focused
                  error={passwordMatchError}
                  type={showPassword.newPassword ? 'text' : 'password'}
                  label={getTranslatedText(
                    intl,
                    'admin.myprofile.security.newPassword.header'
                  )}
                  placeholder={getTranslatedText(
                    intl,
                    'admin.myprofile.security.enterNewPassword.pl'
                  )}
                  onChange={(value) => inputChange(value, 'newPassword')}
                  value={newPassword}
                  suffix={
                    <div className="current-password-visibility-container">
                      {showPassword.newPassword ? (
                        <div onClick={() => showpasswordHandler('newPassword')}>
                          <SVGIcon name="EyeVisible" size="sm" />
                        </div>
                      ) : (
                        <div onClick={() => showpasswordHandler('newPassword')}>
                          <SVGIcon name="EyeHidden" size="sm" />
                        </div>
                      )}
                    </div>
                  }
                />
              </div>
              <div onKeyPress={(e) => handleEnterKey(e, changePassword)}>
                <TextField
                  error={passwordMatchError}
                  type={showPassword.confirmNewPassword ? 'text' : 'password'}
                  label={getTranslatedText(
                    intl,
                    'admin.myprofile.security.confirmNewPassword.header'
                  )}
                  placeholder={getTranslatedText(
                    intl,
                    'admin.myprofile.security.enterConfirmNewPassword.pl'
                  )}
                  onChange={(value) => inputChange(value, 'confirmPassword')}
                  value={confirmNewPassword}
                  suffix={
                    <div className="current-password-visibility-container">
                      {showPassword.confirmNewPassword ? (
                        <div
                          onClick={() =>
                            showpasswordHandler('confirmNewPassword')
                          }
                        >
                          <SVGIcon name="EyeVisible" size="sm" />
                        </div>
                      ) : (
                        <div
                          onClick={() =>
                            showpasswordHandler('confirmNewPassword')
                          }
                        >
                          <SVGIcon name="EyeHidden" size="sm" />
                        </div>
                      )}
                    </div>
                  }
                />
              </div>
              <div className="mt-20 mb-40">
                <Button
                  disabled={isButtonDisbled()}
                  primary
                  loading={buttonloader}
                  onClick={changePassword}
                >
                  <FormattedMessage id="admin.myprofile.security.pass.header" />
                </Button>
              </div>
            </div>
            <div className="mt-20">
              <div className="conditions-block">
                {validationAttributes.map((obj) => {
                  return (
                    <div
                      className={`flex-row flex-align-center password-criteria ${obj.isValid &&
                        'validated-item'}`}
                    >
                      <div className="mr8">
                        <div className="password-validation-text-icon-round" />
                      </div>
                      <div>
                        {obj.helpText({ length: passwordPolicy?.length })}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );
      case 'passcode':
        return (
          <div className="auth-code-container-wrapper flex col fx-sb">
            <div>
              <p className="user-salutation">
                {isBackUpCode ? (
                  <FormattedMessage id="admin.myprofile.security.enter.backupCode" />
                ) : (
                  <FormattedMessage id="admin.myprofile.security.2.factor.authentication.code" />
                )}
              </p>

              <div className="mt-20">
                <Banner status="info">
                  <p className="help-text">
                    {isBackUpCode ? (
                      <FormattedMessage id="admin.myprofile.security.backup.code" />
                    ) : (
                      <FormattedMessage id="admin.myprofile.security.helptext1" />
                    )}
                  </p>
                </Banner>
              </div>
              {!isEmpty(idpError) && (
                <div className="mbt20">
                  <Banner status="critical">
                    {getTranslatedText(intl, errorText?.[idpError?.code])}
                  </Banner>
                </div>
              )}
              <div
                className="mt-40"
                onKeyPress={(e) =>
                  handleEnterKey(
                    e,
                    isBackUpCode ? verifybackUpCode : verifypassCode
                  )
                }
              >
                <OtpInput
                  focused
                  value={passCode}
                  onChange={handleOTPChange}
                  numInputs={isBackUpCode ? 8 : 6}
                  separator={<pre> </pre>}
                  inputStyle={otpInputStyle}
                  isInputNum
                  shouldAutoFocus
                />
              </div>
              {/* {!user && (
                <div>
                  <div className="fx actr mt-20">
                    <Checkbox
                      label="Trust this device for 30 days"
                      checked={trueMe}
                      onChange={handleTrustMeChange}
                    />
                  </div>
                </div>
              )} */}
              <div className="mt-20 mb-40">
                <Button
                  disabled={passCode.length < (isBackUpCode ? 8 : 6)}
                  primary
                  loading={buttonloader}
                  onClick={isBackUpCode ? verifybackUpCode : verifypassCode}
                >
                  Next
                </Button>
              </div>
              {!user && (
                <div onClick={tryAnotherWay} className="link">
                  <FormattedMessage
                    id={
                      resetPasswordPublic
                        ? 'admin.myprofile.security.try.another.way.to.reset.password'
                        : 'admin.myprofile.security.try.another.way'
                    }
                  />
                </div>
              )}
            </div>
            {isBackUpCode && (
              <p className="troubles-accessing-auth-label flex jcenter mt-20">
                <FormattedMessage id="admin.myprofile.security.trouble.accessing.auth" />
              </p>
            )}
          </div>
        );
      default:
        return (
          <div className="current-password-wrapper">
            {user && <p className="user-salutation">Hi {user?.name}</p>}
            <p className="salutation-subtext">
              <FormattedMessage id="admin.myprofile.security.verify.user" />
            </p>
            {!isEmpty(idpError) && (
              <div className="mbt20">
                <Banner status="critical">
                  {getTranslatedText(intl, errorText?.[idpError?.code])}
                </Banner>
              </div>
            )}
            <div className="mt-40">
              <span
                onKeyPress={(e) => handleEnterKey(e, currentPasswordVerify)}
              >
                <TextField
                  focused
                  type={showPassword.currentPassword ? 'text' : 'password'}
                  label={getTranslatedText(
                    intl,
                    'admin.myprofile.security.password.header'
                  )}
                  placeholder={getTranslatedText(
                    intl,
                    'admin.myprofile.security.enterPassword.pl'
                  )}
                  onChange={setCurrentPassword}
                  value={currentPassword}
                  suffix={
                    <div className="current-password-visibility-container">
                      {showPassword.currentPassword ? (
                        <div
                          onClick={() => showpasswordHandler('currentPassword')}
                        >
                          <SVGIcon name="EyeVisible" size="sm" />
                        </div>
                      ) : (
                        <div
                          onClick={() => showpasswordHandler('currentPassword')}
                        >
                          <SVGIcon name="EyeHidden" size="sm" />
                        </div>
                      )}
                    </div>
                  }
                />
              </span>
              <div className="mt-20 mb-40">
                <Button
                  loading={buttonloader}
                  primary
                  disabled={!currentPassword}
                  onClick={currentPasswordVerify}
                >
                  <FormattedMessage id="admin.myprofile.security.next.btn" />
                </Button>
              </div>
              {/* {!user && (
                <div className="link">
                  <Link url={envConfig.base + '/#/forgotpassword'}>
                    <FormattedMessage id="admin.myprofile.security.forgot.password " />
                  </Link>
                </div>
              )} */}
            </div>
          </div>
        );
    }
  };

  const getPasswordResetToken = () => {
    setLoading(true);
    fetchApi(`${envConfig.accountsBasePath}/idp/proxy/password/reset/token`, {
      credentials: 'include',
      headers: {
        ...getIdpHeaders()
      }
    })
      .then(async (res) => {
        if (res.ok && res.status === 200) {
          const data = await res.json();
          setResetToken(data?.token);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (getIdpToken && isMSPBasedonProduct) {
      getPasswordResetToken();
    }
  }, [getIdpToken]);

  return (
    <Wrapper className="fx col w100">
      <div className="card-parent position-relative">
        {props?.isPublic && (
          <div className="position-absolute sparkle-nile">
            <BackgroundIcon
              url={`url(${envConfig.imageRoot}svg/loginsparkle.svg)`}
              alt="Sparkle"
              width="50px"
              height="50px"
            />
          </div>
        )}
        {loading ? (
          <div className="tw-flex tw-items-center tw-justify-center tw-min-w-[450px] tw-min-h-[250px]">
            <Loader />
          </div>
        ) : (
          <>
            <BrandingLogo enableFavIconBrand />
            <div className="auth-component">{renderContent()}</div>
          </>
        )}
      </div>
    </Wrapper>
  );
};

export default injectIntl(SecurityConfig);
